/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSchemaField', [
    '$rootScope',
    '$timeout',

    function ($rootScope, $timeout) {
      function DesignerSchemaField(data) {
        this.name = '';
        this.alias = '';
        this.data_type = 'string';

        this.setData(data);
      }

      DesignerSchemaField.prototype.setData = function (data) {
        this.name = data.name || this.name;
        this.alias = data.alias || this.alias;
        this.data_type = data.data_type || this.data_type;
      };

      DesignerSchemaField.prototype.getData = function () {
        return {
          name: this.name,
          alias: this.alias,
          data_type: this.data_type,
        };
      };

      return DesignerSchemaField;
    },
  ]);
})(window.angular);
